import { type RefObject, useEffect, useState } from "react";

const VIRTUAL_SCROLLER_SELECTOR = ".MuiDataGrid-virtualScroller";

const shouldShowPinnedHeaderShadow = (scroller: HTMLElement | null) =>
  Boolean(
    scroller &&
      scroller.scrollWidth > scroller.clientWidth &&
      scroller.scrollLeft > 0
  );

export const useMarketsDataGridHeaderPin = (
  rootRef: RefObject<HTMLDivElement | null>,
  isLoading: boolean,
  rowCount: number
) => {
  const [isMarketPinned, setIsMarketPinned] = useState(false);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const root = rootRef.current;
    const scroller =
      root?.querySelector<HTMLElement>(VIRTUAL_SCROLLER_SELECTOR) ?? null;

    const updatePinnedState = () => {
      setIsMarketPinned(shouldShowPinnedHeaderShadow(scroller));
    };

    const frameId = window.requestAnimationFrame(updatePinnedState);

    scroller?.addEventListener("scroll", updatePinnedState, { passive: true });

    return () => {
      window.cancelAnimationFrame(frameId);
      scroller?.removeEventListener("scroll", updatePinnedState);
    };
  }, [isLoading, rootRef, rowCount]);

  return isMarketPinned;
};
